// extracted by mini-css-extract-plugin
export default {"container":"Offer_container__vl-jQ","heading":"Offer_heading__2prHT","slideImages":"Offer_slideImages__FgYuq","mobileContainer":"Offer_mobileContainer__8SWgK"};